import { useEffect, useState } from 'react';
import api from '../../api';

const useHttpGetHistoricalData = device_id => {
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState([]);

    const getDeviceHealthReport = async () => {
        try {
            const data = await api.get_historical_data(device_id, 5);
            setData(data);
        } catch (error) {
            console.error('Error happened while loading historical data ', error);
        } finally {
            setIsReady(true);
        }
    };

    useEffect(() => {
        getDeviceHealthReport();
    }, []);

    return { data, isReady };
};

export default useHttpGetHistoricalData;
